/**
 * A narrated walkthrough video with English captions on by default.
 *
 * preload="metadata" so the page doesn't download ~10 MB before anyone
 * presses play; the poster stands in until then.
 */
export function ExplainerVideo({
  src,
  captions,
  poster,
  title,
  caption,
}: {
  src: string;
  captions: string;
  poster: string;
  title: string;
  caption?: string;
}) {
  return (
    <figure className="explainer-video">
      <video controls preload="metadata" playsInline poster={poster} aria-label={title}>
        <source src={src} type="video/mp4" />
        <track kind="captions" src={captions} srcLang="en" label="English" default />
        Your browser can't play this video. <a href={src}>Download it</a> instead.
      </video>
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}
